import { AccessSharingRole } from 'types/entities/AccessSharingRole';
import { RolePermissions } from './types';

export const accessSharingPermissions: RolePermissions = {
  [AccessSharingRole.Viewer]: {
    addNewUser: false,
    revokeOwnAccess: true,
    revokeAllUsersAccess: false,
    changeUserAccess: false,
    editFleet: false,
    editFleetName: false,
    editEquipment: false,
    editInhibitRestart: false,
    editMaintenance: false,
    deleteMaintenance: false,
    deleteFleet: false,
    deleteEquipment: false,
    viewLogs: false,
    shareEquipment: false,
  },
  [AccessSharingRole.Editor]: {
    addNewUser: false,
    revokeOwnAccess: true,
    revokeAllUsersAccess: false,
    changeUserAccess: false,
    editFleet: false,
    editFleetName: false,
    editEquipment: true,
    editInhibitRestart: true,
    editMaintenance: true,
    deleteMaintenance: true,
    deleteFleet: false,
    deleteEquipment: false,
    viewLogs: false,
    shareEquipment: false,
  },
  [AccessSharingRole.Admin]: {
    addNewUser: true,
    revokeOwnAccess: true,
    revokeAllUsersAccess: false,
    changeUserAccess: true,
    editFleet: false,
    editFleetName: false,
    editEquipment: true,
    editInhibitRestart: true,
    editMaintenance: true,
    deleteMaintenance: true,
    deleteFleet: false,
    deleteEquipment: false,
    viewLogs: true,
    shareEquipment: false,
  },
  [AccessSharingRole.Owner]: {
    addNewUser: true,
    revokeOwnAccess: false,
    revokeAllUsersAccess: true,
    changeUserAccess: true,
    editFleet: true,
    editFleetName: true,
    editEquipment: true,
    editInhibitRestart: true,
    editMaintenance: true,
    deleteMaintenance: true,
    deleteFleet: true,
    deleteEquipment: true,
    viewLogs: true,
    shareEquipment: true,
  },
};
